/**
 * Best-effort, never-throws helper for surfacing thrown values to the user.
 * Network errors, custom API errors, raw strings, and undefined all become a
 * human-readable string — never `[object Object]` or `undefined`.
 */
export function describeError(e) {
  if (!e) return "Something went wrong.";
  if (typeof e === "string") return e;
  if (e instanceof Error && e.message) return e.message;
  if (typeof e === "object") {
    if (e.error && typeof e.error === "string") return e.error;
    if (e.message && typeof e.message === "string") return e.message;
  }
  try {
    return String(e);
  } catch (_) {
    return "Something went wrong.";
  }
}
